import * as React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import Svg, { G, Path } from 'react-native-svg';

const LockIcon = (props: { size?: number; containerStyle?: StyleProp<ViewStyle> }) => {
  return (
    <View style={props.containerStyle}>
      <Svg width={34} height={35} viewBox="0 0 34 35" fill="none" {...props}>
        <G filter="url(#filter0_d_3233_3888)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5625 13.5682V11C7.5625 6.3401 11.3401 2.5625 16 2.5625C20.6599 2.5625 24.4375 6.3401 24.4375 11V13.5682C25.831 13.6724 26.7384 13.935 27.4016 14.5984C28.5 15.6967 28.5 17.4645 28.5 21C28.5 24.5355 28.5 26.3032 27.4016 27.4016C26.3032 28.5 24.5355 28.5 21 28.5H11C7.46446 28.5 5.6967 28.5 4.59835 27.4016C3.5 26.3032 3.5 24.5355 3.5 21C3.5 17.4645 3.5 15.6967 4.59835 14.5984C5.26164 13.935 6.16906 13.6724 7.5625 13.5682ZM9.4375 11C9.4375 7.37564 12.3756 4.4375 16 4.4375C19.6244 4.4375 22.5625 7.37564 22.5625 11V13.5045C22.0837 13.5 21.5644 13.5 21 13.5H11C10.4356 13.5 9.91626 13.5 9.4375 13.5045V11ZM18.5 21C18.5 22.3807 17.3807 23.5 16 23.5C14.6192 23.5 13.5 22.3807 13.5 21C13.5 19.6192 14.6192 18.5 16 18.5C17.3807 18.5 18.5 19.6192 18.5 21Z"
            fill="#E2753A"
          />
        </G>
      </Svg>
    </View>
  );
};

export { LockIcon };
